import { MCP_HUMAN_SKILL_TOOL_NAMES } from '../components/mcpChatToolkit';

export const MCP_SKILL_MARKER_PREFIX = '__mcp_skill__:';

const SKILL_MARKER_RE = /__mcp_skill__:([^\s\n]+)/;

export function buildSkillMarker(command: string): string {
  return `${MCP_SKILL_MARKER_PREFIX}${command}`;
}

/** User-visible Persian line + hidden machine marker for the backend. */
export function buildSkillUserMessage(skill: {
  command: string;
  title: string;
}): string {
  const title = skill.title.trim() || skill.command;
  return `اجرای مهارت «${title}»\n${buildSkillMarker(skill.command)}`;
}

/** Extract skill command from user content (marker may be anywhere). */
export function parseSkillMarker(content: string | null | undefined): string | null {
  if (!content) return null;
  const match = content.match(SKILL_MARKER_RE);
  const command = match?.[1]?.trim();
  return command || null;
}

/** Strip machine marker so only the Persian label is shown in the UI. */
export function displaySkillUserMessage(
  content: string | null | undefined
): string {
  if (!content) return '';
  return content
    .replace(SKILL_MARKER_RE, '')
    .replace(/\n{2,}/g, '\n')
    .trim();
}

export const HUMAN_SKILL_TOOL_NAMES = MCP_HUMAN_SKILL_TOOL_NAMES;

export type HumanSkillToolName = (typeof HUMAN_SKILL_TOOL_NAMES)[number];
